import {useTranslation} from 'react-i18next'
import cssMobile from '../../../css/editorMobile.module.css'
import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {handleUpdatedAttributes} from '../../../utils/helpers/attributeHelper'
import FontOption from '../../toolbox/FontOption'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
}

export default function StyleControls({open, onBackClick}: ControlsProps) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const selectedImage = useAppSelector(store =>
    store.editor.images.find(
      image => image.id === store.editor.selectedImageId,
    ),
  )
  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      {selectedImage?.type === 'caption' && (
        <div className={cssMobile.controlItemsRow}>
          <FontOption
            img={selectedImage}
            onClick={() =>
              handleUpdatedAttributes(dispatch, selectedImage, {
                bold: !selectedImage.bold,
              })
            }
            text={t('Félkövér')}
            fontOption="bold"
          />
          <FontOption
            img={selectedImage}
            onClick={() =>
              handleUpdatedAttributes(dispatch, selectedImage, {
                italic: !selectedImage.italic,
              })
            }
            text={t('Dőlt')}
            fontOption="italic"
          />
          <FontOption
            img={selectedImage}
            onClick={() =>
              handleUpdatedAttributes(dispatch, selectedImage, {
                underline: !selectedImage.underline,
              })
            }
            text={t('Aláhúzás')}
            fontOption="underline"
          />
        </div>
      )}
    </ControlsBase>
  )
}
